/**
 * TanStack Query hooks for `referral-partner-program-earn-by-referring-accounts`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	referralPartnerProgramEarnByReferringAccountsQueryKeys,
	type CreateReferralPartnerProgramEarnByReferringAccountsBody,
	type ListReferralPartnerProgramEarnByReferringAccountsResponse,
	type ReferralPartnerProgramEarnByReferringAccountsRow,
} from "./api";

export function useReferralPartnerProgramEarnByReferringAccountsList(): UseQueryResult<ListReferralPartnerProgramEarnByReferringAccountsResponse, Error> {
	return useQuery({
		queryKey: referralPartnerProgramEarnByReferringAccountsQueryKeys.list(),
		queryFn: list,
	});
}

export function useReferralPartnerProgramEarnByReferringAccountsCreate(): UseMutationResult<ReferralPartnerProgramEarnByReferringAccountsRow, Error, CreateReferralPartnerProgramEarnByReferringAccountsBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: referralPartnerProgramEarnByReferringAccountsQueryKeys.all });
		},
	});
}

export function useReferralPartnerProgramEarnByReferringAccountsDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: referralPartnerProgramEarnByReferringAccountsQueryKeys.all });
		},
	});
}
